/**
 * Method to check whether an object is active or inactive by status or date.
 * @param {Number} status - 1 if the status provives is active, 0 otherwise.
 * @param {Date} date - The date of withdrawal.
 * @returns {Boolean} - True if the status is active, false otherwise.
 */
const isActive = (status, date) => {

  if (status && date) {
    const withdrawal = new Date(date)
    const today = new Date()
    
    return (withdrawal >= today && status === 1)
  }

  if (!status && date) {
    const withdrawal = new Date(date)
    const today = new Date()
    return withdrawal >= today    
  }

  if (status && !date) {    
    return status === 1
  }

  if (!status && !date) {    
    return false
  }

  return false

}

export {
  isActive
}